(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestDetails', {
        templateUrl: '/core-ui/component-views/ap-erx-request-details.html',
        bindings: {
            refillRequest: '<',
            prescription: '<?',
            patient: '<?',
        },
        controllerAs: 'vm',
        controller: [
            ApErxRequestDetails,
        ],
    });

    function ApErxRequestDetails(
    ) {
    }

})(window.angular);
